import React, { useState, useEffect } from "react";
import Text from "@ds/components/Text";
import { Box } from "@mui/material";
import color from "@definitions/mui/color";
import { LeftIcon } from "@icons/mobile";
import Link from "next/link";
import useStyles from "../styles";
import { GlobalSearch } from "@layouts/Main/lib/Header/lib/GlobalSearch/GlobalSearch";
interface IProps {
  title?: string;
  withSearchIcon?: boolean;
  backUrl?: string
}

const HeaderStatic: React.FC<IProps> = ({ title, withSearchIcon, backUrl }) => {
  const [scrolled, setScrolled] = useState(false);
  const classes = useStyles({});

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 0) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  });

  return (
    <Box
      px={2}
      position="relative"
      zIndex={1}
      bgcolor={color.white}
      className={scrolled ? classes.stickyHeader : ""}
    >
      <Box width="100%" height="56px" display="flex" alignItems="center">
        <Box width="100%" display="flex" alignItems="center" justifyContent="space-between">
          <Box display="inline-flex" alignItems="center" sx={{ svg: { marginRight: "20px" } }}>
            <Link href={`${backUrl}`}>
              <LeftIcon />
            </Link>
            <Text variant="h3">{title}</Text>
          </Box>
          {withSearchIcon ? <GlobalSearch asInsightList /> : null}
        </Box>
      </Box>
    </Box>
  );
};

export default HeaderStatic;
